import { useState, useEffect, useCallback } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";
import { DollarSign, CheckCircle2, AlertTriangle, Zap } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function BillingTab({ adminToken }) {
  const [data, setData] = useState(null);

  const fetch = useCallback(async () => {
    try { const res = await axios.get(`${API}/admin/billing`, { headers: { Authorization: `Bearer ${adminToken}` } }); setData(res.data); }
    catch (err) { if (err.response?.status === 401) window.location.reload(); }
  }, [adminToken]);

  useEffect(() => { fetch(); }, [fetch]);

  if (!data) return null;

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {[
          { label: "Total Revenue", value: `$${(data.revenue?.total || 0).toFixed(2)}`, icon: DollarSign, color: "emerald" },
          { label: "Paid", value: data.revenue?.paid_count || 0, icon: CheckCircle2, color: "blue" },
          { label: "Pending", value: data.revenue?.pending_count || 0, icon: AlertTriangle, color: "amber" },
          { label: "Stripe", value: data.stripe_connected ? "Connected" : "Not Connected", icon: Zap, color: data.stripe_connected ? "emerald" : "red" },
        ].map((s, i) => (
          <Card key={i} className="bg-white border-[#E5E7EB]"><CardContent className="p-4"><div className="flex items-center gap-3"><div className={`w-9 h-9 rounded-lg flex items-center justify-center bg-${s.color}-500/10`}><s.icon className={`w-4 h-4 text-${s.color}-500`} /></div><div><p className="text-xs text-[#9CA3AF]">{s.label}</p><p className="text-xl font-bold text-[#111827]">{s.value}</p></div></div></CardContent></Card>
        ))}
      </div>
      {data.by_package?.length > 0 && (
        <Card className="bg-white border-[#E5E7EB]"><CardHeader><CardTitle className="text-base text-[#111827]">Revenue by Package</CardTitle></CardHeader><CardContent>
          <Table><TableHeader><TableRow className="border-[#E5E7EB] bg-[#F9FAFB]"><TableHead className="text-[#6B7280]">Package</TableHead><TableHead className="text-center text-[#6B7280]">Sales</TableHead><TableHead className="text-right text-[#6B7280]">Revenue</TableHead></TableRow></TableHeader>
            <TableBody>{data.by_package.map((p, i) => <TableRow key={i} className="border-[#E5E7EB]"><TableCell className="font-medium text-[#111827]">{p.package_id || "Unknown"}</TableCell><TableCell className="text-center text-[#6B7280]">{p.count}</TableCell><TableCell className="text-right font-medium text-[#111827]">${(p.revenue || 0).toFixed(2)}</TableCell></TableRow>)}</TableBody>
          </Table>
        </CardContent></Card>
      )}
    </div>
  );
}
